<script setup lang="ts">
    const props = defineProps<{ blok: BlogTeaserStoryblok }>();
</script>

<template>
    <NewsCard
        v-editable="props.blok"
        :blok="props.blok"
    />
</template>
